(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filtres_femme"] && !Shopify.designMode) return;
  try {
    
(function() {
  const normalizeText = function(value) {
    if (!value) return '';
    return value
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  };

  const closeAllSortDropdowns = function(except) {
    document.querySelectorAll('.sort-dropdown.active').forEach(function(dropdown) {
      if (dropdown !== except) {
        dropdown.classList.remove('active');
      }
    });
  };

  const hydrateColorSwatches = function(panel) {
    if (!panel || panel.dataset.colorSwatchesHydrated === 'true') return;

    panel.querySelectorAll('.color-swatch--filter[data-swatch-image]').forEach(function(swatch) {
      const swatchImage = swatch.getAttribute('data-swatch-image');
      if (!swatchImage) return;
      swatch.style.backgroundImage = 'url(' + swatchImage + ')';
    });

    panel.dataset.colorSwatchesHydrated = 'true';
  };

  const initColorSearch = function(panel) {
    if (!panel || panel.dataset.colorSearchInit === 'true') return;

    const searchInput = panel.querySelector('[data-color-filter-search]');
    const colorOptions = panel.querySelectorAll('[data-color-filter-option]');
    const emptyState = panel.querySelector('[data-color-filter-empty]');

    if (!searchInput || !colorOptions.length) return;
    panel.dataset.colorSearchInit = 'true';

    const filterColorOptions = function() {
      const searchValue = normalizeText(searchInput.value);
      let visibleCount = 0;

      colorOptions.forEach(function(option) {
        const optionLabel = option.getAttribute('data-color-label') || option.textContent;
        const isVisible = searchValue === '' || normalizeText(optionLabel).indexOf(searchValue) !== -1;
        option.classList.toggle('is-hidden', !isVisible);
        if (isVisible) visibleCount += 1;
      });

      if (emptyState) {
        emptyState.classList.toggle('is-visible', visibleCount === 0);
      }
    };

    searchInput.addEventListener('input', filterColorOptions);
    filterColorOptions();
  };

  const initSortDropdown = function(dropdown) {
    if (!dropdown || dropdown.dataset.sortInit === 'true') return;

    const toggle = dropdown.querySelector('.sort-toggle');
    if (!toggle) return;
    dropdown.dataset.sortInit = 'true';

    toggle.addEventListener('click', function(event) {
      event.stopPropagation();
      const isActive = dropdown.classList.contains('active');
      closeAllSortDropdowns();
      dropdown.classList.toggle('active', !isActive);
    });
  };

  const shouldAnimateNavigation = function(link) {
    if (!link || !link.getAttribute('href')) return false;
    if (link.target && link.target !== '' && link.target !== '_self') return false;
    if (link.hasAttribute('download')) return false;
    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return false;
    }
    return url.origin === window.location.origin;
  };

  const bindAnimatedNavigation = function(section, panel, closePanel) {
    const links = section.querySelectorAll('.filter-pill, .sort-option');
    const panelLinks = panel ? panel.querySelectorAll('.filters-panel-option, .filters-panel-cta, .filters-panel-reset') : [];
    const allLinks = Array.prototype.slice.call(links).concat(Array.prototype.slice.call(panelLinks));

    allLinks.forEach(function(link) {
      if (link.dataset.animatedNavBound === 'true') return;
      link.dataset.animatedNavBound = 'true';

      link.addEventListener('click', function(event) {
        if (event.defaultPrevented) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (!shouldAnimateNavigation(link)) return;

        event.preventDefault();
        closePanel();
        closeAllSortDropdowns();
        document.body.classList.add('page-transitioning');
        window.setTimeout(function() {
          window.location.href = link.href;
        }, 240);
      });
    });
  };

  const initFiltersSection = function(section) {
    if (!section || section.dataset.filtersInit === 'true') return;

    const sectionId = section.getAttribute('data-filters-section-id');
    if (!sectionId) return;

    const panel = document.querySelector('.filters-panel[data-filters-section-id="' + sectionId + '"]');
    const overlay = document.querySelector('.filters-overlay[data-filters-section-id="' + sectionId + '"]');
    const openButton = section.querySelector('.filter-toggle');
    const closeButton = panel ? panel.querySelector('.filters-panel-close') : null;
    const sortDropdown = section.querySelector('.sort-dropdown');

    if (!panel || !overlay || !openButton) return;

    section.dataset.filtersInit = 'true';
    openButton.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');

    initSortDropdown(sortDropdown);
    initColorSearch(panel);
    bindAnimatedNavigation(section, panel, function() { closePanel(); });

    const closePanel = function() {
      panel.classList.remove('active');
      overlay.classList.remove('active');
      panel.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('.filters-panel.active')) {
        document.body.classList.remove('filters-panel-open');
      }
    };

    const openPanel = function() {
      document.querySelectorAll('.filters-panel.active').forEach(function(activePanel) {
        if (activePanel !== panel && typeof activePanel.__closeFiltersPanel === 'function') {
          activePanel.__closeFiltersPanel();
        }
      });
      hydrateColorSwatches(panel);
      panel.classList.add('active');
      overlay.classList.add('active');
      panel.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('filters-panel-open');
    };

    openButton.addEventListener('click', function(event) {
      event.preventDefault();
      if (panel.classList.contains('active')) {
        closePanel();
      } else {
        openPanel();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', closePanel);
    }

    overlay.addEventListener('click', closePanel);
    panel.__closeFiltersPanel = closePanel;
  };

  const runInit = function(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.collection-filters-section[data-filters-section-id]').forEach(initFiltersSection);
  };

  if (!window.__filtresFemmeGlobalBound) {
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.sort-dropdown')) {
        closeAllSortDropdowns();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.filters-panel.active').forEach(function(panel) {
        if (typeof panel.__closeFiltersPanel === 'function') {
          panel.__closeFiltersPanel();
        }
      });
    });

    window.__filtresFemmeGlobalBound = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      runInit(document);
    });
  } else {
    runInit(document);
  }

  if (!window.__filtresFemmeSectionLoadBound) {
    document.addEventListener('shopify:section:load', function(event) {
      runInit(event.target);
    });
    window.__filtresFemmeSectionLoadBound = true;
  }
})();

  } catch(e) { console.error(e); }
})();
})();
